import { createElement } from 'react';
import { Input } from '@alifd/next';
const StringFilter = ({ onChange, name, fieldName }) => {
    const __onChange = (value) => {
        onChange({
            operator: 'like',
            dataType: 'string',
            value,
            name,
            fieldName,
        });
    };
    return createElement(Input, { className: "filter-input", onChange: __onChange, trim: true, hasClear: true });
};
export default StringFilter;
